<template>
  <div>
     <v-card class="rounded-lg pa-2" elevation="2"> 
      <div class="banner">
        <span>Vínculos de {{ resource.name }}</span>
      </div>

      <v-data-table :headers="headers" :items="vinculos" :search="search"
        :footer-props="{ 'items-per-page-text': 'Vínculos por Página' }">
        <template v-slot:[`item.profile_user_unities`]="{ item }">
          <div class="d-flex flex-wrap align-center">
            <v-chip v-if="item.profile_user_unities.length > 0" :color="setProfileColor(item)" text-color="red" small
              class="ma-1">
              {{ setProfileName(item) }}
            </v-chip>

            <v-menu v-if="item.profile_user_unities.length > 1" v-model="item.showMenu" offset-y>
              <template #activator="{ props }">
                <v-chip v-bind="props" color="#bce8d3" text-color="red" small class="ma-1 cursor-pointer"
                  @click.stop="active(item), (item.showMenu = !item.showMenu)">
                  +{{ item.profile_user_unities.length - 1 }}
                </v-chip>
              </template>

              <v-list dense style="max-height: 200px; overflow-y: auto; min-width: 200px">
                <span class="ml-3">Outros Perfis</span>

                <v-list-item v-for="(perfis, index) in item.profile_user_unities" :key="index">
                  <v-list-item-title>{{ perfis.profile.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>{{
            item.deleted_at ? "Inativo" : "Ativo"
          }}</v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <Menu :resource="item" @openLinkModal="(vinculoDialog = true), (resourceItem = item)">
            <ChangeStatus :resource="item" typeData="not-delete" @updateGrid="loadUserUnityProfiles()"
              url="users/userUnity" />
          </Menu>
        </template>
      </v-data-table>

      <v-btn class="d-flex justify-end rounded-lg" color="#41916b" @click="$router.push('/usuarios')" dark>{{$t('buttons.return')}}</v-btn>

      <v-dialog v-model="vinculoDialog" max-width="600px" persistent>
        <v-card class="rounded-lg pa-4">
          <VinculoForm :resource="resourceItem" @closeDialog="(vinculoDialog = false)" />
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import VinculoForm from "./Link.vue";
import { mapActions } from "vuex";
import axios from "@/axios";

export default {
  data() {
    return {
      search: "",
      vinculos: [],
      resource: {},
      resourceItem: {},
      headers: [
        { text: "Unidade Hospitalar", align: "start", value: "unity.hospital" },
        { text: "Perfis Vinculados", align: "start", value: "profile_user_unities" },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      actions: [
        {
          name: "Editar Vínculo",
          type: "linkModal",
          route: " ",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "vinculoForm",
        },
      ],
      vinculoDialog: false,
    };
  },

  mounted() {
    this.loadUserUnityProfiles();
  },

  computed: {
    setProfileName() {
      return item => item?.profile_user_unities?.[0]?.profile?.name || 'PERFIL INATIVADO';
    },

    setProfileColor() {
      return item => item?.profile_user_unities?.[0]?.profile ? '#bce8d3' : 'red-darken-4';
    }
  },

  created() {
    this.changeActionsData(this.actions);
    this.resource = this.$route.query.item;
  },

  methods: {
    ...mapActions([
      "changeIndicatorFormEdit",
      "changeActionsData",
    ]),

    loadUserUnityProfiles() {
      axios.get(`/users/get/userUnityProfile/${this.resource.id}`).then((response) => {
        this.vinculos = response.data ? response.data : response.data.data;
      });
    },

  },

  components: {
    Menu,
    VinculoForm,
    ChangeStatus,
  },
};
</script>
<style scoped>
.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #41916b, #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #41916b, #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 12px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>span {
  color: #ffffff;
  font-size: 15px;
  padding: 14px;
}
</style>
